import { axios } from "@/config";
const api = {
    getUploadConfig: '/Coze/getUploadConfig'
}

/**
 * 获取上传配置
 * @param {*} data
 */
export function getUploadConfig(data) {
  return axios({
    url: api.getUploadConfig,
    method: 'post',
    data
  })
}